import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {color, mr, pb, pt} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailHeader: React.FC<IProps> = ({vendor}) => {
    const theme = useTheme();

    return (
        <div css={vendorDetailHeaderBase}>
            <Image alt={`${vendor.name} logo`} src={vendor.logo.v_log_120x90} width="120" height="90" css={logoStyles} />

            <div>
                <SeoMainHeadline as="h1" variant="headline_2" css={[vendorNameStyle]} className="bt">
                    {vendor.name}
                </SeoMainHeadline>

                {vendor.headquarters && (
                    <Text as="address" variant="body_copy_1" css={[color(theme.colors.gray["600"])]}>
                        {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                    </Text>
                )}
            </div>
        </div>
    );
};

const vendorDetailHeaderBase = css`
    display: flex;
    flex-direction: row;
`;

const logoStyles = (theme: Theme) => css`
    flex: 0 0 auto;
    align-self: center;
    ${mr(2)};
    height: 6rem;

    & > img {
        width: auto;
        height: 100%;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        height: 10rem;
    }
`;

const vendorNameStyle = (theme: Theme) => css`
    ${pt(0.5)};
    ${pb(0.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${pt(1)};
        ${pb(2)};
    }
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {color, mr, pb, pt} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailHeader: React.FC<IProps> = ({vendor}) => {
    const theme = useTheme();

    return (
        <div css={vendorDetailHeaderBase}>
            <Image alt={`${vendor.name} logo`} src={vendor.logo.v_log_120x90} width="120" height="90" css={logoStyles} />

            <div>
                <SeoMainHeadline as="h1" variant="headline_2" css={[vendorNameStyle]} className="bt">
                    {vendor.name}
                </SeoMainHeadline>

                {vendor.headquarters && (
                    <Text as="address" variant="body_copy_1" css={[color(theme.colors.gray["600"])]}>
                        {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                    </Text>
                )}
            </div>
        </div>
    );
};

const vendorDetailHeaderBase = css`
    display: flex;
    flex-direction: row;
`;

const logoStyles = (theme: Theme) => css`
    flex: 0 0 auto;
    align-self: center;
    ${mr(2)};
    height: 6rem;

    & > img {
        width: auto;
        height: 100%;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        height: 10rem;
    }
`;

const vendorNameStyle = (theme: Theme) => css`
    ${pt(0.5)};
    ${pb(0.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${pt(1)};
        ${pb(2)};
    }
`;
